var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridItem, GridItemBorder } from '../../common/components/Grid';
import { ThemedMedia } from '../../common/components/Media';
import LinkSectionGroup, { LinkSectionDataShape } from './LinkSectionGroup';
import Accordion from './Accordion';
var FooterLinkSection = function (_a) {
    var general = _a.general, help = _a.help, payment = _a.payment, international = _a.international, shipping = _a.shipping, social = _a.social, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(ThemedMedia, { defaultMatches: { desktop: false } }, function (_a) {
        var desktop = _a.desktop;
        return (React.createElement(Accordion, { active: !desktop, defaultOpen: ['general'] }, function (_a) {
            var isOpen = _a.isOpen, toggle = _a.toggle;
            return (React.createElement(React.Fragment, null,
                React.createElement(Grid, { pt: [null, null, 3], legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
                    React.createElement(GridItem, { w: [1, null, 6 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, general, { sectionName: "general", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItem, { w: [1, null, 6 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, help, { sectionName: "help", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItem, { w: [1, null, 3 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, payment, { sectionName: "payment", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItem, { w: [1, null, 3 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, shipping, { sectionName: "shipping", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItem, { w: [1, null, 3 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, international, { sectionName: "international", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItem, { w: [1, null, 3 / 12] },
                        React.createElement(LinkSectionGroup, __assign({}, social, { sectionName: "social", isOpen: isOpen, isActive: !desktop, onTitleClick: toggle }))),
                    React.createElement(GridItemBorder, { display: ['none', null, 'block'] }))));
        }));
    }));
};
FooterLinkSection.propTypes = {
    /** General link section */
    general: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Help link section */
    help: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Shipping link section */
    shipping: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Payment link section */
    payment: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** International link section */
    international: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Social link section */
    social: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
FooterLinkSection.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default FooterLinkSection;
